import React from 'react';
import classnames from 'classnames';
import './Divider.scss';

interface DividerProps {
  stretch?: 'sm' | 'md';
  testid?: string;
  color?: string;
  inverseColor?: boolean;
}

const Divider: React.FC<DividerProps> = ({ stretch, testid, inverseColor }) => {
  const layoutDividerClassNames = classnames(
    'layoutDivider',
    stretch && `stretch--${stretch}`,
    inverseColor && 'inverseColor'
  );

  return <hr className={layoutDividerClassNames} data-testid={testid} />;
};

export default Divider;
